import React, { useState } from 'react';

import './Info.scss';

type InfoComponentProps = {
  displayIcon?: boolean;
  iconHoverElement?: JSX.Element;
  header?: JSX.Element;
  body?: JSX.Element;
};

function Info({ displayIcon, iconHoverElement, header, body }: InfoComponentProps) {
  const [showInfo, setShowInfo] = useState(false);

  const handleSetShowInfo = () => {
    if (!showInfo) {
      setShowInfo(true);
    }
  };

  return (
    <div className={'info'}>
      <span onMouseOver={() => handleSetShowInfo()} onMouseOut={() => setShowInfo(false)}>
        {!displayIcon && iconHoverElement ? iconHoverElement : <span>&#9432;</span>}
      </span>
      <div className={`info${showInfo ? '__active' : '__hide'}`}>
        <span className={'info__header'}>{header}</span>
        <div className={'info__body'}>{body}</div>
      </div>
    </div>
  );
}

export default Info;
